import { jwtDecode } from 'jwt-decode';

interface UserToken {
  sub: string;
  email: string;
  name: string;
  company: string;
  roles: string[];
  iat: number;
  exp: number;
  role?: string;
}

export const getUser = (): UserToken => {
  const token = localStorage.getItem('auth-token');
  const user: UserToken = jwtDecode(token || '');

  const role: string = user.roles.shift() || '';
  const userRole = role.charAt(0).toUpperCase() + String(role.toLocaleLowerCase()).slice(1);

  return { ...user, role: userRole };
};
